import { getRequest } from '../../utils'

export type OrganizationFeatureFlagsSettings = Partial<Record<string, '0' | '1'>>

export interface FetchOrganizationFeatureFlagsResponseData {
  settings: OrganizationFeatureFlagsSettings
}

export const fetchOrganizationFeatureFlags = (
  organizationId: string,
): Promise<FetchOrganizationFeatureFlagsResponseData> => {
  return getRequest(`/v2/organizations/${organizationId}/settings/feature-flag`)
}
